import { Outlet } from "react-router-dom";

const AccountingMainPage = () => {
    return <Outlet />;
}

export default AccountingMainPage;